export const deckArray = [
  {
    suits: "Heart",
    card: "A",
    color: "red",
    index: "1"
  },
  {
    suits: "Heart",
    card: "6",
    color: "red",
    index: "2"
  },
  {
    suits: "Heart",
    card: "7",
    color: "red",
    index: "3"
  },
  {
    suits: "Heart",
    card: "8",
    color: "red",
    index: "4"
  },
  {
    suits: "Heart",
    card: "9",
    color: "red",
    index: "5"
  },
  {
    suits: "Heart",
    card: "10",
    color: "red",
    index: "6"
  },
  {
    suits: "Heart",
    card: "J",
    color: "red",
    index: "7"
  },
  {
    suits: "Heart",
    card: "Q",
    color: "red",
    index: "8"
  },
  {
    suits: "Heart",
    card: "K",
    color: "red",
    index: "9"
  },
  {
    suits: "Diamond",
    card: "A",
    color: "red",
    index: "10"
  },
  {
    suits: "Diamond",
    card: "6",
    color: "red",
    index: "11"
  },
  {
    suits: "Diamond",
    card: "7",
    color: "red",
    index: "12"
  },
  {
    suits: "Diamond",
    card: "8",
    color: "red",
    index: "13"
  },
  {
    suits: "Diamond",
    card: "9",
    color: "red",
    index: "14"
  },
  {
    suits: "Diamond",
    card: "10",
    color: "red",
    index: "15"
  },
  {
    suits: "Diamond",
    card: "J",
    color: "red",
    index: "16"
  },
  {
    suits: "Diamond",
    card: "Q",
    color: "red",
    index: "17"
  },
  {
    suits: "Diamond",
    card: "K",
    color: "red",
    index: "18"
  },
  {
    suits: "Club",
    card: "A",
    color: "black",
    index: "19"
  },
  {
    suits: "Club",
    card: "6",
    color: "black",
    index: "20"
  },
  {
    suits: "Club",
    card: "7",
    color: "black",
    index: "21"
  },
  {
    suits: "Club",
    card: "8",
    color: "black",
    index: "22"
  },
  {
    suits: "Club",
    card: "9",
    color: "black",
    index: "23"
  },
  {
    suits: "Club",
    card: "10",
    color: "black",
    index: "24"
  },
  {
    suits: "Club",
    card: "J",
    color: "black",
    index: "25"
  },
  {
    suits: "Club",
    card: "Q",
    color: "black",
    index: "26"
  },
  {
    suits: "Club",
    card: "K",
    color: "black",
    index: "27"
  }, 
  {
    suits: "Spade",
    card: "A",
    color: "black",
    index: "28"
  },
  {
    suits: "Spade",
    card: "6",
    color: "black",
    index: "29"
  },
  {
    suits: "Spade",
    card: "7",
    color: "black",
    index: "30"
  },
  {
    suits: "Spade",
    card: "8",
    color: "black",
    index: "31"
  },
  {
    suits: "Spade",
    card: "9",
    color: "black",
    index: "32"
  },
  {
    suits: "Spade",
    card: "10",
    color: "black",
    index: "33"
  },
  {
    suits: "Spade",
    card: "J",
    color: "black",
    index: "34"
  },
  {
    suits: "Spade",
    card: "Q",
    color: "black",
    index: "35"
  },
  {
    suits: "Spade",
    card: "K",
    color: "black",
    index: "36"
  }
];

export const additionalCards = [
  {
    suits: "Heart",
    card: "2",
    color: "red",
    index: "37"
  },
  {
    suits: "Heart",
    card: "3",
    color: "red",
    index: "38"
  },
  {
    suits: "Heart",
    card: "4",
    color: "red",
    index: "39"
  },
  {
    suits: "Heart",
    card: "5",
    color: "red",
    index: "40"
  },
  {
    suits: "Diamond",
    card: "2",
    color: "red",
    index: "41"
  },
  {
    suits: "Diamond",
    card: "3",
    color: "red",
    index: "42"
  },
  {
    suits: "Diamond",
    card: "4",
    color: "red",
    index: "43"
  },
  {
    suits: "Diamond",
    card: "5",
    color: "red",
    index: "44"
  },
  {
    suits: "Club",
    card: "2",
    color: "black",
    index: "45"
  },
  {
    suits: "Club",
    card: "3",
    color: "black",
    index: "46"
  },
  {
    suits: "Club",
    card: "4",
    color: "black",
    index: "47"
  },
  {
    suits: "Club",
    card: "5",
    color: "black",
    index: "48"
  },
  {
    suits: "Spade",
    card: "2",
    color: "black",
    index: "49"
  },
  {
    suits: "Spade",
    card: "3",
    color: "black",
    index: "50"
  },
  {
    suits: "Spade",
    card: "4",
    color: "black",
    index: "51"
  },
  {
    suits: "Spade",
    card: "5",
    color: "black",
    index: "52"
  },
];